import { IFolder } from '@opengov/reporting-types';
import { useMutation } from '@tanstack/react-query';
import { getMutationFn } from '../../../../../../apiHooks/core/rest/useFetchMutation';

export type CreateReportFolderPayload = {
  entityId: number;
  title: string;
  parentFolderId: string | null;
};

export const useCreateReportFolder = () => {
  const mutationKey = ['createReportFolder'];
  const reportFolderMutationFn = getMutationFn<{ data: IFolder }, CreateReportFolderPayload>({ errorType: 'text' });

  return useMutation(
    async (reportFolderPayload: CreateReportFolderPayload) =>
      reportFolderMutationFn({ url: `/api/reporting_service/v4/folders`, body: reportFolderPayload }),
    { mutationKey }
  );
};
